import styled from "@emotion/styled";

const Form = styled.form``;
Form.defaultProps = { className: 'lx-form' };

export default Form;
